(function () {
  if (!customElements.get("announcement-rotator")) {
    customElements.define(
      "announcement-rotator",
      class AnnouncementRotator extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll(".announcement-bar__slide"));
          if (this.slides.length < 2) return;

          this.index = 0;
          this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 4000);
          // A reader who cannot outrun the timer is worse off than one who sees a
          // single message, so leave it parked on the first when motion is reduced.
          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

          this.start();
          this.addEventListener("mouseenter", () => this.stop());
          this.addEventListener("mouseleave", () => this.start());
          this.addEventListener("focusin", () => this.stop());
          this.addEventListener("focusout", () => this.start());
          document.addEventListener("visibilitychange", this.onVisibility);
        }

        disconnectedCallback() {
          this.stop();
          document.removeEventListener("visibilitychange", this.onVisibility);
        }

        onVisibility = () => {
          if (document.hidden) this.stop();
          else this.start();
        };

        start() {
          this.stop();
          this.timer = setInterval(() => this.advance(), this.interval);
        }

        stop() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }

        advance() {
          const previous = this.slides[this.index];
          this.index = (this.index + 1) % this.slides.length;
          const next = this.slides[this.index];

          previous.classList.remove("is-active");
          previous.setAttribute("aria-hidden", "true");
          next.classList.add("is-active");
          next.removeAttribute("aria-hidden");
        }
      }
    );
  }

  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
